import { Tag } from "antd";
import { TagProps } from "antd/lib/tag";

interface MultiSelectLabelTagProps extends Omit<TagProps, "onClose"> {
  value?: string | number;
  label: React.ReactNode;
  onTagClose?: (event: React.MouseEvent, value: string | number) => void;
}

export const MultiSelectLabelTag = ({
  value,
  label,
  onTagClose,
  className,
  ...tagProps
}: MultiSelectLabelTagProps) => {
  const handleMouseDown = (e: React.MouseEvent) => {
    // Prevent mousedown event if clicking close icon
    if (
      e.target instanceof Element &&
      (e.target.classList.contains("anticon-close") ||
        e.target.closest(".anticon-close"))
    ) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const handleClose = (e: React.MouseEvent) => {
    if (onTagClose && value !== undefined) {
      onTagClose(e, value);
    }
  };

  return (
    <Tag
      className={`!flex flex-row ${className || ""}`}
      closable
      onMouseDown={handleMouseDown}
      onClose={handleClose}
      {...tagProps}
    >
      {label}
    </Tag>
  );
};
